/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { ListingPageTrackingProps } from './useListingPageTracking.types';
import { trackPage } from 'shared/helpers/trackPage';
import {
    hasMortgageCalculator,
    removeNullAnalyticValues
} from 'listing-details/helpers';
import { createMortgageTrackingLabel } from 'listing-details/components/MortgageCalculator/MortgageCalculator.tracking';
import { useRouter } from 'next/router';

export const useListingPageTracking = ({
    data,
    listingSection
}: ListingPageTrackingProps): void => {
    const { query } = useRouter();
    const page = `/${data.section}/details/`;

    const ecommerce = {
        detail: {
            products: [removeNullAnalyticValues(data.analyticsEcommerce)]
        }
    };

    let mortgageProvideLabel;

    if (hasMortgageCalculator(data.analyticsTaxonomy.priceQualifier)) {
        mortgageProvideLabel = createMortgageTrackingLabel({
            data,
            listingSection
        });
    }

    const taxonomy = removeNullAnalyticValues({
        activity: 'listing_details',
        mortgage_calculator_displayed: '',
        page,
        url: data.listingUris.detail,
        search_identifier: (query['search_identifier'] as string) || null,
        ...data.analyticsTaxonomy,
        ...(mortgageProvideLabel && { mortgage_provider: mortgageProvideLabel })
    });

    useEffect(() => {
        trackPage(page, taxonomy, ecommerce);
    }, [data.analyticsTaxonomy.listingId]);
};
